module.exports = __webpack_public_path__ + "static/media/window.0482117b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/window.jpeg
// module id = 303
// module chunks = 0